import React from 'react';
import notFound from '../../images/notfound/dribbble_1.gif'

const NotFound = () => {
    return (
        <div className='text-center'>
            <img src={notFound} alt="" />
        </div>
    );
};

export default NotFound;